
import React, { Component } from 'react'
import './syshome.less'

class sysHome extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }
  render() {
    return (
      <div className="topic">
        <div className='page-home'>
          <div className="page-img" />
        </div>

      </div>
    )
  }
}

export default sysHome